import { Box } from '@mui/material';
import { RecordingHistoryItem } from './TherapistRecordingView';

export const RecordingOperationHistory = ({
  operationHistory,
}: {
  operationHistory: any[];
}) => (
  <Box>
    {operationHistory.map((item: any) => (
      <RecordingHistoryItem item={item} key={item.id || item._id} />
    ))}
  </Box>
);
